import 'bootstrap/dist/js/bootstrap.bundle';
import '../styles/index.scss';

// Klaro CMP
import 'klaro/dist/klaro.css';
import * as Klaro from 'klaro';
import klaroConfig from './klaro-config';

window.klaro = Klaro;
window.klaroConfig = klaroConfig;
Klaro.setup(klaroConfig);

// home-video
document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('home-video');
    if (video) {
        window.addEventListener('scroll', () => {
            if (scrollY > video.getBoundingClientRect().y) {
                video.play();
            }
        });
    }
});
